<article class="collector-row">
  <div class="collector-summary">
    <button
      type="button"
      class="collector-chip"
      [attr.aria-label]="'Copy ' + row.name"
      [attr.title]="'Copy collector name'"
      (click)="copyName()"
    >
      {{ row.name }} <span aria-hidden="true">⧉</span>
    </button>
    <span class="collector-score" [attr.title]="'Collector score: ' + row.score">
      Score {{ row.score }}
    </span>
    <span class="collector-team">{{ row.team || 'No team' }}</span>
    <span class="free-summary" [class.missing-summary]="row.availabilityState === 'missing'">{{ availabilitySummary }}</span>
    <span class="free-period" *ngIf="row.freeForEntireSelectedRange">Entire selected period</span>
    <span class="free-period" *ngIf="!row.freeForEntireSelectedRange && row.freeMinutesInSelectedRange > 0">
      Part of selected period
    </span>
    <span *ngIf="copied" class="copied-feedback" role="status" aria-live="polite">Copied</span>
  </div>
  <app-availability-timeline
    [collectorName]="row.name"
    [segments]="row.timeline"
    [selectedFromMinute]="selectedFromMinute"
    [selectedToMinute]="selectedToMinute"
    [clearPinnedTick]="clearPinnedTick"
    (pinnedChange)="onPinnedChange($event)"
  ></app-availability-timeline>
</article>
